import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState, QuoteOrderPayload } from "../types/order.types";
import { DriveFileUpload } from "../types/upload.types";

/* ------------------------------ SLICE ------------------------------- */

export const orderSlice = createSlice({
	name: "order",
	initialState,
	reducers: {
		/* --------------------------- ORDER QUOTE --------------------------- */
		orderQuoteRequested: (state, _: PayloadAction<QuoteOrderPayload>) => {
			state.loading = true;
			state.error = null;
		},
		orderQuoteSuccess: (state, action: PayloadAction<number>) => {
			state.loading = false;
			state.orderId = action.payload;
		},
		orderQuoteError: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload;
		},

		/* -------------------------- ORDER UPDATE ------------------------- */

		orderItemUpdateRequested: (
			state,
			_: PayloadAction<{ file: DriveFileUpload }>
		) => {
			state.error = null;
		},
		orderItemUpdateSuccess: (state) => {
			state.loading = false;
		},
		orderItemUpdateError: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload;
		},

		/* --------------------- MARK ORDER COMPLETE ------------------------- */
		markOrderCompleteRequested: (state) => {
			state.loading = true;
			state.error = null;
		},
		markOrderCompleteSuccess: (state) => {
			state.loading = false;
			state.isCompleted = true;
		},
		markOrderCompleteError: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload;
			state.isCompleted = false;
		},

		clearOrderData: () => initialState,
	},
});

/* ---------------------------- EXPORT ACTIONS ------------------------- */

export const {
	orderQuoteRequested,
	orderQuoteSuccess,
	orderQuoteError,
	orderItemUpdateRequested,
	orderItemUpdateSuccess,
	orderItemUpdateError,
	markOrderCompleteRequested,
	markOrderCompleteSuccess,
	markOrderCompleteError,
	clearOrderData,
} = orderSlice.actions;

export default orderSlice.reducer;
